import { getDocument } from 'pdfjs-dist'

import './pdfWorker'

// Extracts plain text from a PDF entirely in-memory in the browser via
// pdf.js — the caller must never persist or upload the raw `data` buffer;
// only the string this returns should leave the calling component.
export async function extractPdfText(data: ArrayBuffer): Promise<string> {
  const pdf = await getDocument({ data }).promise

  const pageTexts: string[] = []

  for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
    const page = await pdf.getPage(pageNumber)
    const textContent = await page.getTextContent()

    const pageText = textContent.items
      .map((item) => ('str' in item ? item.str : ''))
      .join(' ')

    pageTexts.push(pageText)
  }

  return pageTexts.join('\n\n').trim()
}
